const AU_DOMAIN = 'com.au';
const NZ_DOMAIN = 'co.nz';
const TARGET_DOMAIN = '{domain}';
const TARGET_FALLBACK_DOMAIN = '{fallbackDomain}';
const TARGET_REGEX = '{(.*?)}';

export default (value: any): any => {
  if (value === undefined) {
    return;
  }

  if (typeof value === 'string') {
    const match = value.match(TARGET_REGEX);
    if (match) {
      const host = window.location.host;
      const target = match[0];
      if (target === TARGET_DOMAIN) {
        return value.replace(
          target,
          host.includes(AU_DOMAIN) ? AU_DOMAIN : NZ_DOMAIN,
        );
      }
      if (target === TARGET_FALLBACK_DOMAIN) {
        return value.replace(
          target,
          host.includes(AU_DOMAIN) ? NZ_DOMAIN : AU_DOMAIN,
        );
      }
    }
  }
  return value;
};
